import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const useCashBalanceState = () => {
  return useSelector((state: RootState) => state.filterRecordCashBalance);
};
